<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1816 35C28.4659 35 35.1816 28.2843 35.1816 20C35.1816 11.7157 28.4659 5 20.1816 5C11.8974 5 5.18164 11.7157 5.18164 20C5.18164 28.2843 11.8974 35 20.1816 35ZM20.9316 8.75V19.6893L28.212 26.9697L27.1513 28.0303L19.6513 20.5303L19.4316 20.3107V20V8.75H20.9316Z"
      class="fill-current"
    />
  </svg>
</template>
